//import firebase from 'firebase/app';
//import 'firebase/auth';
import { firebaseApp } from './firebaseConfiguration'; // Adjust path if needed
import { getAuth, signOut, GoogleAuthProvider, signInAnonymously, signInWithPopup, signInWithRedirect, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';

export const googleSignin = () => {
  //const provider = new firebase.auth.GoogleAuthProvider();
  const auth = getAuth(firebaseApp); // Get the auth instance
  const provider = new GoogleAuthProvider();
  //firebase.auth().signInWithPopup(provider)
  //signInWithPopup(auth, provider)
  signInWithRedirect(auth, provider)
    .then((result) => console.log('successfully logged in ', result.user.displayName))
    .catch((error) => console.error('There was an error when signing in with Google: ', error));
}

export const facebookSignin = () => {
  //const provider = new firebase.auth.FacebookAuthProvider();
  const auth = getAuth(firebaseApp); // Get the auth instance
  const provider = new GoogleAuthProvider();
  //firebase.auth().signInWithPopup(provider)
  signInWithPopup(auth, provider)
    .then((result) => console.log('successfully logged in: ', result.user.displayName))
    .catch((error) => console.error('There was an error when signing in with Facebook: ', error));
}

export const twitterSignin = () => {
  //const provider = new firebase.auth.TwitterAuthProvider();
  const auth = getAuth(firebaseApp); // Get the auth instance
  const provider = new GoogleAuthProvider();
  //firebase.auth().signInWithPopup(provider)
  signInWithPopup(auth, provider)
    .then((result) => console.log('successfully logged in: ', result.user.displayName))
    .catch((error) => console.error('There was an error when signing in with Twitter: ', error));
}

export const signOutUser = () => {  //it was signOut(), but caused recursive call
  const auth = getAuth(firebaseApp); // Get the auth instance
  //firebase.auth().signOut()
  signOut(auth)
    .then(() => console.log('User successfully signed out'))
    .catch((error) => console.error('There was an error when signing out: ', error));
}

export const emailSignin = (email, password) => {
  const auth = getAuth(firebaseApp); // Get the auth instance
  //firebase.auth().signInWithEmailAndPassword(email, password)
  signInWithEmailAndPassword(auth, email, password)
    .then(() => console.log('User successfully signed in with email and password.'))
    .catch((error) => console.error('There was an error while signing in with email and password: ', error));
}

export const createEmailSigninAccount = (email, password) => {
  const auth = getAuth(firebaseApp); // Get the auth instance
  //firebase.auth().createUserWithEmailAndPassword(email, password)
  createUserWithEmailAndPassword(auth, email, password)
    .then(() => console.log('User successfully created an account with email and password'))
    .catch((error) => console.error('There was an error while creating a new user with email and password: ', error));
}

/*export const anonymousSignin = () => {
  firebase.auth().onAuthStateChanged((user) => {
    if (!user) {
      firebase.auth().signInAnonymously()
        .then(() => console.log('User successfully signed in anonymously'))
        .catch((error) => console.error('There was an error while signing in anonymously: ', error));
    }
  });
}*/

export async function anonymousSignin() { // Assuming it's an async function
  /* Enable anonymous sign in later
  try {
    const auth = getAuth(firebaseApp); // Get the auth instance
    const userCredential = await signInAnonymously(auth); // Use the modular signInAnonymously
    const user = userCredential.user;
    console.log("Signed in anonymously:", user.uid);
    return user;
  } catch (error) {
    console.error("Error signing in anonymously:", error);
    // Handle specific errors, e.g., if anonymous auth is not enabled
    if (error.code === 'auth/operation-not-allowed') {
      alert("Anonymous authentication is not enabled. Please enable it in the Firebase console.");
    }
    throw error; // Re-throw or handle as appropriate for your app
  }*/
}